"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidCountriesResponseToJSON = exports.ValidCountriesResponseFromJSONTyped = exports.ValidCountriesResponseFromJSON = void 0;
var _1 = require("./");
function ValidCountriesResponseFromJSON(json) {
    return ValidCountriesResponseFromJSONTyped(json, false);
}
exports.ValidCountriesResponseFromJSON = ValidCountriesResponseFromJSON;
function ValidCountriesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'defaultCountryCode': json['defaultCountryCode'],
        'countries': (json['countries'].map(_1.CountryInfoFromJSON)),
    };
}
exports.ValidCountriesResponseFromJSONTyped = ValidCountriesResponseFromJSONTyped;
function ValidCountriesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'defaultCountryCode': value.defaultCountryCode,
        'countries': (value.countries.map(_1.CountryInfoToJSON)),
    };
}
exports.ValidCountriesResponseToJSON = ValidCountriesResponseToJSON;
//# sourceMappingURL=ValidCountriesResponse.js.map